import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from '../ui/badge';
import { Instagram, Linkedin, MessageCircle } from 'lucide-react';

export const SiteFooter = () => {
  return (
    <footer className="bg-card border-t py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div className="space-y-4">
              <img
                src="https://customer-assets.emergentagent.com/job_wellness-journeys/artifacts/amcb4t0p_Generated_image%20%281%29.png"
                alt="Therapy with Ayesha"
                className="h-20 w-auto"
                data-testid="footer-logo"
              />
              <p className="text-sm text-muted-foreground">
                Ayesha Khaleel, M.A. in Clinical Psychology<br />
                Compassionate, Safe, Confidential Care
              </p>
            </div>

            <div className="space-y-4">
              <h3 className="font-semibold">Quick Links</h3>
              <nav className="flex flex-col space-y-2">
                <Link to="/" className="text-sm text-muted-foreground hover:text-primary">Home</Link>
                <Link to="/services" className="text-sm text-muted-foreground hover:text-primary">Services</Link>
                <Link to="/resources" className="text-sm text-muted-foreground hover:text-primary">Healing Resources</Link>
                <a href="#contact" className="text-sm text-muted-foreground hover:text-primary">Contact</a>
              </nav>
            </div>

            <div className="space-y-4">
              <h3 className="font-semibold">Contact</h3>
              <p className="text-sm text-muted-foreground">Email: ayesha.k.psychologist@gmail.com</p>
              <p className="text-sm text-muted-foreground">Phone: +91 80737 69515</p>
              <div className="flex items-center gap-3 pt-1">
                <a
                  href="https://www.instagram.com/_ayesha__psychologist/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  data-testid="footer-instagram"
                  className="w-9 h-9 rounded-full bg-secondary/40 hover:bg-primary hover:text-primary-foreground flex items-center justify-center transition-colors"
                >
                  <Instagram className="w-4 h-4" />
                </a>
                <a
                  href="https://www.linkedin.com/in/ayesha-khaleel-923506216/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  data-testid="footer-linkedin"
                  className="w-9 h-9 rounded-full bg-secondary/40 hover:bg-primary hover:text-primary-foreground flex items-center justify-center transition-colors"
                >
                  <Linkedin className="w-4 h-4" />
                </a>
                <a
                  href="https://wa.me/918073769515"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="WhatsApp"
                  data-testid="footer-whatsapp"
                  className="w-9 h-9 rounded-full bg-secondary/40 hover:bg-primary hover:text-primary-foreground flex items-center justify-center transition-colors"
                >
                  <MessageCircle className="w-4 h-4" />
                </a>
              </div>
              <Link to="/admin" className="text-xs text-muted-foreground/70 hover:text-primary inline-block" data-testid="footer-admin-link">
                Practitioner Login →
              </Link>
            </div>
          </div>

          <div className="border-t pt-8">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <p className="text-sm text-muted-foreground order-2 md:order-1">
                © 2026 Therapy with Ayesha. All rights reserved.
              </p>
              <div className="flex items-center gap-3 order-1 md:order-2">
                <span className="text-xs text-muted-foreground uppercase tracking-wider mr-1 hidden sm:inline">
                  Listed on
                </span>
                <a
                  href="https://www.therapyroute.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Verified by Therapy Route"
                  data-testid="therapy-route-badge"
                  className="block"
                >
                  <img
                    src="https://customer-assets.emergentagent.com/job_wellness-journeys/artifacts/qimh3j1p_TR%20logo.jpg"
                    alt="Verified by Therapy Route"
                    className="h-12 w-auto object-contain rounded-sm"
                  />
                </a>
              </div>
            </div>
            <div className="flex gap-4 justify-center mt-6">
              <Badge variant="outline" className="text-xs">SAFE</Badge>
              <Badge variant="outline" className="text-xs">COMPASSIONATE</Badge>
              <Badge variant="outline" className="text-xs">CONFIDENTIAL</Badge>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
